import { render, staticRenderFns } from "./Pageindex.vue?vue&type=template&id=56907b3a"
import script from "./Pageindex.vue?vue&type=script&lang=js"
export * from "./Pageindex.vue?vue&type=script&lang=js"
import style0 from "./Pageindex.vue?vue&type=style&index=0&id=56907b3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports